import type { TokenSizeProps } from '@mnd-frontend/icons/utils/type';
import type { ComponentType } from 'react';

export const mapIconComponent = (
  icon: keyof typeof iconMap | string | null | undefined,
  iconMap: { [key: string]: ComponentType<TokenSizeProps> },
): ComponentType<TokenSizeProps> | undefined =>
  typeof icon === 'string' && Object.hasOwn(iconMap, icon)
    ? iconMap[icon as keyof typeof iconMap]
    : undefined;
